import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddWishListToCartItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackAddWishListToCartParameters
    extends TrackEventListParameters<"currency" | "value", null, TrackAddWishListToCartItem> {}

const trackAddWishListToCart = (
    parameters: TrackAddWishListToCartParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const action: Toolkit.GoogleAnalytics.AnyEventName = "add_wishlist_to_cart";
    const data = ga.track.eventList({ action, ...parameters }, { ...options, skipTracking: true });

    return ga.track.eventList({ action, ...data, items: data.items?.filter(x => !x.inactive) }, options);
};

export default trackAddWishListToCart;
